import axios from "axios";
import { STATUSES } from "./apiStatus";
import { base_url } from "../utils";
import { getAccesstoken } from "../helpers/utils";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");
const CACHE_TTL = 2 * 60 * 1000;

const rechargeCacheKey = (walletId) =>
  `digilocker_recharge_history_v2_${walletId}`;

export const invalidateRechargeCache = () => {
  try {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith("digilocker_recharge_"))
      .forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // No action is required when browser storage is unavailable.
  }
};

export const creditRch = createAsyncThunk(
  "creditRch/fetch",
  async (request, { rejectWithValue }) => {
    const controlledRequest =
      request && typeof request === "object" && "walletId" in request;
    const walletId = controlledRequest ? request.walletId : request;
    const forceRefresh = controlledRequest && request.forceRefresh;
    const cacheKey = rechargeCacheKey(walletId);

    try {
      if (!forceRefresh) {
        try {
          const cached = JSON.parse(sessionStorage.getItem(cacheKey));
          if (
            cached?.data &&
            Date.now() - cached.savedAt < CACHE_TTL
          ) {
            return cached.data;
          }
          sessionStorage.removeItem(cacheKey);
        } catch {
          sessionStorage.removeItem(cacheKey);
        }
      }
      const token = getAccesstoken();
      const response = await axios.get(
        `${base_url}/digilocker/get_credit_recharge_logs/${walletId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      try {
        sessionStorage.setItem(
          cacheKey,
          JSON.stringify({ savedAt: Date.now(), data: response.data }),
        );
      } catch {
        // Requests continue normally when browser storage is unavailable.
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to load recharge history.",
      );
    }
  },
);

const creditRchSlice = createSlice({
  name: "creditRch",
  initialState: {
    creditRchdata: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(creditRch.pending, (state, action) => {
        state.status = STATUSES.LOADING;
        state.error = null;
      })
      .addCase(creditRch.fulfilled, (state, action) => {
        state.creditRchdata = action.payload;
        state.status = STATUSES.IDLE;
        state.error = null;
      })
      .addCase(creditRch.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error =
          action.payload ||
          action.error?.message ||
          "Unable to load recharge history.";
      });
  },
});

export default creditRchSlice.reducer;
